<template>
  <div
    class="me-badge bold action-font"
    :class="smallNotification ? 'small-badge' : ''"
  >
    <span v-if="showTotalCount">{{ totalcount }}</span>
  </div>
</template>

<script>
export default {
  name: 'NotificationCount',

  props: {
    totalcount: {
      type: Number,
      required: false,
      default: 0,
    },
    showTotalCount: {
      type: Boolean,
      required: false,
      default: false,
    },
    smallNotification: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.me-badge {
  @apply bg-attention-bg text-attention-text;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  min-width: 20px;
  box-sizing: border-box;
  width: auto;
  height: 16px;
  font-size: 11px;
  text-align: center;
  padding: 2px 5px 2px 5px;
  line-height: 13px;
  margin-left: auto;

  &.small-badge {
    @apply absolute
      top-2
      right-1.5
      z-[1]
      p-0
      h-1.5
      min-w-[0.375rem]
      outline
      outline-background-strongest;
  }
}
</style>
